import { DetailItem } from '@components/process-details/detail-item';
import { ProcessDetails } from '@components/process-details/process-details';
import { useProcess } from '@react-query/hooks/query/use-process';

export const ProcessInfo = () => {
    const { data: process, isPending, isSuccess } = useProcess();

    if (!isSuccess) {
        return null;
    }

    const { child, applicantParent, approverParent, created } = process;

    return (
        <ProcessDetails isLoading={isPending} data-testid="approver-parent-process-details" withTitle>
            <ProcessDetails.Section>
                <DetailItem.CreatedDate date={created} />
                <DetailItem.AccountOwner name={child.name} />
                <DetailItem.Parents applicantName={applicantParent.name} approverName={approverParent.name} />
            </ProcessDetails.Section>
        </ProcessDetails>
    );
};
